import { Route } from '@angular/router';
import { provideStates } from '@ngxs/store';
import { HotelsApiService } from './services/hotels-api.service';
import { HotelsSearchFormService } from './services/hotels-search-form.service';
import { HotelsState } from './state/hotels.state';

export const hotelsPageRouteConfig: Route = {
  path: 'hotels',
  loadComponent: () => import('./hotels-page.component').then((c) => c.HotelsPageComponent),
  providers: [provideStates([HotelsState]), HotelsApiService, HotelsSearchFormService]
};
